<script>
    import {WKT} from 'ol/format';
    import {Feature} from 'ol';
    import FeatureMap from "./FeatureMap.svelte";
    import Point from "ol/geom/Point";

    export let gisLayer;
    export let soilMapUnitCode;
    export let siblingPolygons = [];
    export let pinCoordinate;

    const fmt = new WKT();

    $: envelope = siblingPolygons.map(polygon => {
            try {
                return fmt.readGeometry(polygon.shape);
            } catch (e) {
                return null;
            }
        }).find(e => !!e);

    $: features = Array.isArray(pinCoordinate) && pinCoordinate.length > 1 ? [new Feature(new Point(pinCoordinate))] : []
</script>

<style>
    :global(div.sibling-map) {
        height: 600px;
        width: 100%;
    }

    /*@media print {
        :global(div.sibling-map) {
            height: 280px;
            width: 100%;
        }
    }*/
</style>

{#if siblingPolygons && siblingPolygons.length}
    <p>
        Areas with {gisLayer}\{soilMapUnitCode} map unit code are shown on the map below. A soil map unit is a collection of areas that have the same soils (i.e. siblings) in the same proportion.
    </p>

    <FeatureMap {envelope} {gisLayer} {soilMapUnitCode} {features} mapClass={"sibling-map"}/>
{/if}

